export default class Directive {
  private name: string;

  private description: string;

  private type: string;

  constructor(obj: any = {}) {
    this.name = obj.name;
    this.description = obj.description;
    this.type = obj.type;
  }

  public static of(value: any): Directive {
    return new Directive(value || {});
  }
}
